import { Icon, IconProps } from '../Icon';

export const NotiIcon = (props: IconProps) => <Icon size="16px" className="mr-2.5" {...props} />;
